import { Link } from 'react-router';
import AlertIcon from '@/assets/icons/alert.svg?react';
import { ROUTES } from '@/shared/config/routes';
import { BadgeIcon } from '@/shared/ui/badge-icon';
import { Button } from '@/shared/ui/button';

export function LinkInvalidView() {
  return (
    <>
      <span data-enter="">
        <BadgeIcon tone="bad">
          <AlertIcon className="size-5.5" />
        </BadgeIcon>
      </span>
      <div data-enter="" className="flex flex-col gap-2" role="alert">
        <h1 className="font-semibold text-title-lg">This link does not work</h1>
        <p className="text-muted">
          It may be incomplete, or it was made for another browser session. Ask for a new one.
        </p>
      </div>
      <Button data-enter="" asChild variant="primary" size="lg" isBlock>
        <Link to={ROUTES.SIGN_IN}>Back to sign in</Link>
      </Button>
    </>
  );
}
